module.exports = __webpack_public_path__ + "static/img/map5.b4c1814.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/divinemap/map5.png
// module id = 64t8
// module chunks = 1